<!-- <div class="mt-3"> -->
<mat-form-field
  (keydown)="logKey($event)"
  appearance="fill"
  class="w-full form-design-ui app__attributes-form-field app__reporting-form-field"
  (click)="$event.stopPropagation(); selectedCategoryItem = undefined"
  [floatLabel]="!isFetchedCategories && control?.value ? 'always' : ''"
>
  <mat-label class="automtic-form-desing-lable"> {{ control?.title }}</mat-label>
  <mat-select
    #select
    (closed)="onSelectClosed($event)"
    [(ngModel)]="categoryValue"
    [(value)]="categoryValue"
    [disableOptionCentering]="true"
    (valueChange)="handleLogChange($event)"
    (keydown)="logKey($event)"
    (openedChange)="onOpenedChange($event)"
    panelClass="income__expense--category--dropdown"
  >
    <div class="h-auto max-h-[285px] w-full flex-col">
      <div class="mx-2 my-3 h-10">
        <div class="income__expense--category--header items-center justify-around h-full">
          <mat-form-field appearance="fill" class="w-full app__attributes-search-field">
            @if (!selectedCategoryItem) {
            <input
              #myInput
              matInput
              type="text"
              class="w-[80%] pl-[10px] h-full outline-none"
              autocomplete="off"
              placeholder="Search Categories"
              (keydown.space)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              (input)="handleSearch($event.target.value)"
            />
            } @if (selectedCategoryItem) {
            <input
              #myInput
              matInput
              type="text"
              class="w-[80%] pl-[10px] h-full outline-none"
              autocomplete="off"
              [placeholder]="'Search in ' + selectedCategoryItem?.name ?? 'parentCategoryName'"
              (keydown.space)="$event.stopPropagation()"
              (click)="$event.stopPropagation()"
              (input)="handleSearch($event.target.value)"
            />
            }
          </mat-form-field>
          <mat-icon class="text-[#C2C3C7]">search</mat-icon>
        </div>
      </div>
      @if (!isFetchedCategories && control?.value){
      <mat-option [value]="categoryValue ?? control?.value ?? premiumCategoryValue" class="p-0">
        <span class="py-[6px] pt-[14px] pb-[10px] w-full h-full bg-[#f3f6fa] flex px-4">{{ categoryValue ?? control?.value }}</span>
      </mat-option>
      }
      <div class="h-auto">
        @if (isFetchedCategories) { @if (!selectedCategoryItem) {
        <div
          [class]="
            !isAddingNewExpenseCategory
              ? 'h-auto max-h-[175px] overflow-y-auto w-full flex-col pb-3 bg-light-blue'
              : 'h-auto max-h-[70px] overflow-y-auto w-full flex-col pb-3 min-h-[60%]'
          "
        >
          <mat-option [value]="control?.value ?? ''" class="p-0 hidden">
            <span class="py-[6px] pt-[14px] pb-[10px] w-full h-full bg-[#f3f6fa] flex px-4">{{ control?.value ?? '' }}</span>
          </mat-option>

          @for (item of expenseCategories; track item) {
          <mat-option [value]="item?.name">
            <div class="h-[37px] flex text-k-black justify-between items-center w-full" (click)="selectCategory($event, item)">
              <p class="m-0">
                <span class="py-[6px] pt-[14px] pb-[10px] text-sm">{{ item?.name }}</span>
              </p>
              <span class="material-icons material-icons icons-close-mobile text-k-black">chevron_right</span>
            </div>
          </mat-option>
          }
        </div>
        }@else {
        <mat-option>
          <div class="h-[37px] w-full gap-2 items-center flex" (click)="selectCategory($event, selectedCategoryItem)">
            <span class="material-icons material-icons icons-close-mobile text-k-black">chevron_left</span>

            <p class="m-0">
              <span class="py-[6px] pt-[14px] pb-[10px]">{{ selectedCategoryItem?.name }}</span>
            </p>
          </div>
        </mat-option>
        <div
          [class]="
            !isAddingNewExpenseCategory
              ? 'h-auto max-h-[120px] overflow-y-auto w-full flex-col pb-3 min-h-[60%]'
              : 'h-auto max-h-[35px] overflow-y-auto w-full flex-col pb-3 min-h-[60%]'
          "
        >
          @for (item of filteredSubCategories; track item) {
          <mat-option [value]="item?.name" class="p-0">
            <span class="py-[6px] pt-[14px] pb-[10px] w-full h-full bg-[#f3f6fa] flex px-4">{{ item?.name }}</span>
          </mat-option>
          } @if (filteredSubCategories.length < 1) {
          <div class="income__expense--category--list overflow-y-auto">
            <div class="app__centered-item w-full text-center h-[100px]">
              <p class="w-[65%] text-[#707070]">There are no subcategories here, please add one to select</p>
            </div>
          </div>
          }
        </div>
        }}
      </div>

      <mat-divider></mat-divider>
      @if (!isAddingNewExpenseCategory) {
      <div class="min-h-[56px] max-h-[166px] mx-2">
        <button class="app__btn--transparent bg-transparent justify-start font-bold text-sm pt-[18px]" (click)="addNewExpenseCategory($event)">
          <span class="material-icons mt-[-3px]">add</span>
          {{ selectedCategoryItem ? ' Add new ' + transactionType + ' subcategory' : ' Add new ' + transactionType + ' category' }}
        </button>
      </div>
      } @if (isAddingNewExpenseCategory) {
      <div class="min-h-[56px] max-h-[166px] mx-2">
        <button class="app__btn--transparent bg-transparent justify-start font-bold text-sm pt-[18px]" (click)="addNewExpenseCategory($event)">
          <span class="material-icons mt-[-3px]">add</span>
          {{ selectedCategoryItem ? ' Add new ' + transactionType + ' subcategory' : ' Add new ' + transactionType + ' category' }}
        </button>

        <div
          [class]="
            isAddingNewExpenseCategory
              ? 'h-auto max-h-[145px] overflow-y-auto w-full flex-col'
              : 'h-auto max-h-[85px] overflow-y-auto w-full flex-col'
          "
        >
          <mat-form-field
            appearance="fill"
            class="pt-[16px] form__mat-text-field income__expense--category--field"
            (keydown)="$event.stopPropagation()"
            (click)="$event.stopPropagation()"
          >
            <mat-label class="automtic-form-desing-lable">
              {{ selectedCategoryItem ? 'Enter Subcategory Name' : 'Enter Category Name' }}
            </mat-label>
            <input #categoryInput matInput type="text" [formControl]="createCategoryControl" class="h-full w-full outline-none" />
            @if (createCategoryControl.hasError('foundError') && createCategoryControl.value == '') {
            <mat-error> {{ selectedCategoryItem ? 'Subcategory' : 'Category' }} name required </mat-error>
            } @if (createCategoryControl.hasError('foundError') && createCategoryControl.value !== '') {
            <mat-error> A {{ selectedCategoryItem ? 'Subcategory' : 'Category' }} with that name already exists </mat-error>
            }
          </mat-form-field>
          <div class="income__expense--category--actions">
            <button
              class="app__btn--primary--small w-fit bg-transparent text-[#707070] py-[8px] px-3 !important"
              (click)="closeFormSection(); $event.stopPropagation()"
            >
              Cancel
            </button>
            <button
              class="app__btn--primary--small w-[57px] ml-2 pt-[7px] rounded-lg z-50"
              (click)="
                !selectedCategoryItem
                  ? createIncomeExpenseCategoryOrSubcategory('category')
                  : createIncomeExpenseCategoryOrSubcategory('sub-category');
                $event.stopPropagation()
              "
            >
              Save
            </button>
          </div>
        </div>
      </div>
      }
    </div>
  </mat-select>
</mat-form-field>
